import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import ProductDeleteCompleteTemplate from 'components/Templates/product/ProductDeleteCompleteTemplate'

const ProductDeleteComplete: FC = () => {
  return (
    <Layout title={'削除｜sacriで出品する商品の管理'}>
      <ProductDeleteCompleteTemplate />
    </Layout>
  )
}

export default ProductDeleteComplete
